<template>
  <div class="page bg-confirm d-flex align-items-center justify-content-center">
    <div class="card shadow py-4 card-wrapper text-center">
      <div class="hero-circle mx-auto mb-4 d-flex align-items-center justify-content-center">
        <img
          :src="`${aws}/dashboard/svg/account/licorne.svg`"
          alt="licorne assurup"
          class="hero-image"
        >
      </div>
      <div class="d-flex flex-column align-items-center gap-2">
        <h3 class="mb-0">
          <span class="highlight highlight-blue-300">Goodbye <span class="animate">👋</span></span>
        </h3>
        <h4 class="fw-semibold">
          <span class="highlight highlight-blue-300">Votre compte a été supprimé</span>
        </h4>
        <v-feedback
          :seconds="seconds"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { routing } from '@/mixins';
import Feedback from '@/components/confirmation/Feedback.vue';


export default defineComponent({
  name: 'DeletedAccount',
  components: {
    'v-feedback': Feedback,

  },
  mixins: [routing],
  data() {
    return {
      seconds: 15,
    };
  },
  computed: {
    aws: () => `${import.meta.env.VITE_AWS_STATIC}`,
  },
  mounted() {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = () => {
      window.history.go(1);
    };
  },
});
</script>

<style scoped>
.page {
  min-height: 100vh;
  width: 100%;
  padding: 64px 16px;
}

.bg-confirm {
  text-align: center;
  background-position: 60% 40%;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url('https://assurup-assets-1.s3.eu-west-3.amazonaws.com/app/widget/svg/survey/bg-confirm.svg');
}

.card-wrapper {
  max-width: 720px;
  width: 100%;
  border-radius: 20px;
}

.hero-circle {
  width: 200px;
  height: 200px;
  background-color: rgb(0, 100, 227);
  border-radius: 50%;
}

.hero-image {
  width: 120px;
  height: auto;
}

.animate {
  display: inline-block;
  animation: wave 2s infinite;
  transform-origin: 70% 70%;
}
@keyframes wave {
  0% { transform: rotate(0deg); }
  15% { transform: rotate(14deg); }
  30% { transform: rotate(-8deg);  }
  40% { transform: rotate(14deg); scale: 1.1;}
  50% { transform: rotate(-4deg); }
  60% { transform: rotate(10deg); }
  70% { transform: rotate(0deg); }
  100% { transform: rotate(0deg); }
}

</style>
